<template>
  <v-container class="Notification">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <v-toolbar class="my-md-auto " elevation="0" rounded="lg">
      <v-toolbar-title  class="hidden-sd-and-down">
          <h2><v-icon large class="mr-2" >mdi-content-save-all</v-icon>{{ $t('administration.backup.backup')}}</h2>
      </v-toolbar-title>
      <v-spacer />
      <div class="d-inline-flex">
        <v-btn
          class="ml-2"
          :to="{ name: 'BackupList' }"
        >
          {{ $t('global.back')}}
        </v-btn>

      </div>
    </v-toolbar>

    <div  v-if="item">
      <v-row>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="4" >
              <strong class="ml-4">{{ $t('global.date') }}:</strong>
            </v-col>
            <v-col md="8">
              <span class="mr-2">{{ formatDateTime(item['date'], 'long') }}</span>
            </v-col>
          </v-row>

        </v-col>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="4" >
              <strong class="ml-4">{{ $t('administration.backup.finished') }}:</strong>
            </v-col>
            <v-col md="8">
              <span class="mr-2">{{ formatDateTime(item['finished'], 'long') }}</span>
            </v-col>
          </v-row>

        </v-col>

      </v-row>
      <v-row>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="4" >
              <strong class="ml-4">{{ $t('administration.backup.address') }}:</strong>
            </v-col>
            <v-col md="8">
              <span class="mr-2">{{ item['address'] }}</span>
            </v-col>
          </v-row>

        </v-col>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="4" >
              <strong class="ml-4">{{ $t('administration.backup.size') }}:</strong>
            </v-col>
            <v-col md="8">
              <span class="mr-2">{{ item['size'] }}</span>
            </v-col>
          </v-row>

        </v-col>

      </v-row>
      <v-row>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="4" >
              <strong class="ml-4">{{ $t('administration.backup.auto') }}:</strong>
            </v-col>
            <v-col md="8">
              <span class="mr-2">{{ item['auto'] }}</span>
            </v-col>
          </v-row>

        </v-col>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="4" >
              <strong class="ml-4">{{ $t('administration.backup.success') }}:</strong>
            </v-col>
            <v-col md="8">
              <span class="mr-2">{{ item['success'] }}</span>
            </v-col>
          </v-row>

        </v-col>

      </v-row>


    </div>
    </v-sheet>
      <Loading :visible="isLoading" />
  </v-container>

</template>


<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';

const servicePrefix = 'Backup';

export default {
  name: 'BackupShow',
  servicePrefix,
  components: {
      Loading,
  },
  mixins: [ShowMixin],
  computed: {
    ...mapFields('backup', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('backup', ['find'])
  },
  methods: {
    ...mapActions('backup', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
